'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// Players


var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _vbiClientCollector = require('vbi-client-collector');

var _vbiClientCollector2 = _interopRequireDefault(_vbiClientCollector);

require('videojs-overlay');

require('video.js/dist/video-js.css');

require('./vjs.css');

var _defaultConfig = require('./config/defaultConfig');

var _VideoPlayer = require('./VideoPlayer');

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

var _HiveVideoPlayer = require('./HiveVideoPlayer');

var _HiveVideoPlayer2 = _interopRequireDefault(_HiveVideoPlayer);

var _RampVideoPlayer = require('./RampVideoPlayer');

var _RampVideoPlayer2 = _interopRequireDefault(_RampVideoPlayer);

var _MicrosoftECDNVideoPlayer = require('./MicrosoftECDNVideoPlayer');

var _MicrosoftECDNVideoPlayer2 = _interopRequireDefault(_MicrosoftECDNVideoPlayer);

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dmInstance = _DebugManager2.default.dmInstance;

var VideoManager = function () {
  function VideoManager(dataHandler, errorHandler, playingHandler) {
    var _this = this;

    _classCallCheck(this, VideoManager);

    this.setupTextTracks = function (vttUrl) {
      if (!vttUrl) return false;
      var opts = {
        kind: 'captions',
        label: 'captions on',
        src: vttUrl
      };
      _this.videoPlayer && _this.videoPlayer.addRemoteTextTrack(opts);

      // the following is a workaround to keep the VTT captions positioned
      // correctly. We should remove this once we upgrade videojs.
      // WN-2186
      window.addEventListener('resize', function () {
        _this.videoPlayer.textTrackDisplay.updateDisplay();
      });

      return true;
    };

    this.setupOverlay = function (player) {
      var sentimentObject = document.getElementById('sentimentWidget');
      player.overlay({
        debug: false,
        overlays: [{
          content: sentimentObject,
          start: 'playing',
          end: 'ended'
        }]
      });
    };

    this.initiateEventListeners = function () {
      var isPreview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      /*
        Event processing will change from polling to inband
        when the `playingHandler` is called. We wanting to maintain
        polling during preview because events are not sent inband
        when the event has not yet started.
        WN-3598
      */
      if (!isPreview) {
        _this.videoPlayer.on('playing', _this.playingHandler);
      }
    };

    this.dataHandler = dataHandler || this.missingHandler;
    this.errorHandler = errorHandler || this.missingHandler;
    this.playingHandler = playingHandler || this.missingHandler;
  }

  _createClass(VideoManager, [{
    key: 'missingHandler',
    value: function missingHandler() {
      throw new Error('Missing handler function!');
    }
  }, {
    key: 'constructPlayer',
    value: function constructPlayer(videoId, videoConfig, urls, vbiConfig, eventId, vbiAccountId, userId, type, isPreview, presentationType, authParams) {
      var _this2 = this;

      // initialize the player with <video> id and configuration values:
      // all video players return a promise
      var videoPlayer = void 0;
      var videoPlayerPromise = void 0;

      // Retrieve a video config.
      // The configuration generator will ensure that the correct html5/hls options
      // and correct plugins are loaded based on the current device/browser.
      var config = (0, _defaultConfig.getPlayerConfig)(urls, this.errorHandler, this.dataHandler, type, videoConfig, presentationType);
      var extendedConfig = _extends({}, config, videoConfig, { params: authParams }, {
        userId: userId,
        eventId: eventId,
        urls: urls,
        presentationType: presentationType
      });

      dmInstance.logMessage([_DebugManager2.default.debugLevel.M], '[VideoManager] player configuration: ', extendedConfig);

      if (videoConfig.hiveEnabled) {
        videoPlayer = _HiveVideoPlayer2.default;
      } else if (videoConfig.microsoftEnabled) {
        videoPlayer = _MicrosoftECDNVideoPlayer2.default;
      } else if (videoConfig.rampEnabled) {
        extendedConfig.fallbackUrls = urls;
        // this can be overridden using mAddr query param
        extendedConfig.mAddr = '239.0.0.1:12345';
        videoPlayer = _RampVideoPlayer2.default;
      } else {
        videoPlayer = _VideoPlayer2.default;
      }

      videoPlayerPromise = videoPlayer(videoId, extendedConfig);
      videoPlayerPromise.then(function (player) {
        if (!player) return null;
        _this2.videoPlayer = player;
        _this2.initiateEventListeners(isPreview);
        if (!isPreview) {
          _this2.initiateVBI(vbiConfig, eventId, vbiAccountId, userId, presentationType, extendedConfig.ipAddress);
        }
        _this2.setupTextTracks(extendedConfig.videoVTTUrl);
        _this2.setupOverlay(player);
      }).catch(function (error) {
        console.error('[VideoManager] constructPlayer() Error inititating video player:' + error);
      });
      return { promise: videoPlayerPromise, player: videoPlayer };
    }
  }, {
    key: 'destroyPlayer',
    value: function destroyPlayer() {
      this.videoPlayer && this.videoPlayer.dispose();
    }
  }, {
    key: 'initiateVBI',
    value: function initiateVBI(conf, eventId, vbiAccountId, userId, presentationType, ipAddress) {
      // If no account config passed in then forget it
      if ((0, _isUndefined2.default)(conf) || (0, _isEmpty2.default)(conf)) return;
      var vbi = new _vbiClientCollector2.default(conf);
      vbi.registerObject(this.videoPlayer, {
        type: 'videojs', eventId: eventId, accountId: vbiAccountId, userId: userId, eventType: presentationType, ipAddress: ipAddress
      });
    }
  }]);

  return VideoManager;
}();

exports.default = VideoManager;